// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_74c70dd","withHeading":"_9cdd13a","oneSlide":"_e767425","imageWrapper":"_c607da2","imageText":"_cb031d1"};